import React from 'react'
import './NoMatch.css'

function NoMatch() {
  return (
    <div id='noMatch' className='text-center'>
      <h3 className='text-muted py-5'>
        The page you requested either does not exist or is currently
        unavailable.
      </h3>
      <p className='text-center'>
        <a href='/'>
          <i className='fas fa-home'></i>
        </a>
      </p>
    </div>
  )
}

export default NoMatch
